<template>
  <div class="chart-bar-box" ref="chartBarBox">
    <div class="chart-title-styl" v-if="chartTitleVisible">{{chartTitle}}</div>
    <div class="chart-cont-styl" v-if="!placeholdVisible">
      <el-select
        v-model="searchCriteria"
        placeholder="请选择"
        size="small"
        class="select-style"
        @change="handleSelectBar"
        v-if="dimType === 1">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!-- 日期选择器 日 月-->
      <el-date-picker
        v-if="dimType === 0 && (queryCondition == 'data_day' || queryCondition == 'data_month')"
        v-model="searchCriteriaDate"
        :type="queryCondition == 'data_day' ? 'daterange': 'monthrange'"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleSelectBar"
        :format="queryCondition == 'data_day' ? 'yyyy 年 MM 月 dd 日': 'yyyy 年 MM 月'"
        :value-format="queryCondition == 'data_day' ? 'yyyy-MM-dd': 'yyyy-MM'"
        size="small"
        class="select-style">
      </el-date-picker>
       <div v-if="dimType === 0 && queryCondition == 'data_year'">
        <el-date-picker
          v-model="curStartYear"
          size="small"
          type="year"
          format="yyyy"
          value-format="yyyy"
          placeholder="开始日期"
          @change="handleChangeStart"
          class="select-style"
        >
        </el-date-picker>
        <span style="padding-left: 12px">至</span>
        <el-date-picker
          v-model="curEndYear"
          size="small"
          placeholder="结束日期"
          type="year"
          format="yyyy"
          value-format="yyyy"
          @change="handleChangeEnd"
          class="select-style"
        >
        </el-date-picker>
      </div>
      <div :style="chartBarStyl" ref="chartBar"></div>
    </div>
    <img
      src="http://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/01/1642400355706.png" alt=""
      v-if="placeholdVisible"
      class="placehold-img"
    >
  </div>
</template>

<script>
const echarts = require('echarts');
export default {
  name: "chartBar",
  props: {
    receiveProps:{
      type: [Object, Array],
      default: ()=>{}
    }
  },
  data() {
    return {
      placeholdVisible: false, //是否展示占位图
      chartTitle: '',// 图表名称
      chartTitleVisible:false, //名称显隐
      dimType: '', // 是否有查询条件
      queryCondition: '',// 查询条件 字符串 日 月 年
      curStartYear: '', //开始年份
      curEndYear: '', //结束年份
      chartOption:{
        tooltip: { //提示
          trigger: 'axis'
        },
        legend: {
          show: true,
          left: '16px'
        },// 标签
        xAxis: { //x轴设置
          type: 'category',
          data: [],
          axisLabel :{
            interval:0,
            rotate: 0  
          },
          axisLine:{ //x轴
            show: true
          }
        },
        // calculable : true,
        dataZoom : {//实现缩放功能
          show : false,
          realtime : false,
          start : 0,
          end : 100,
          brushSelect: false
        },
        yAxis: { // y轴设置
          type: 'value',
          axisLine:{ //y轴
            show: true
          },
          splitLine: { //网格线
            show: true
          },
        },
        series: [ //数据
          {
            itemStyle: {
              normal: {
                color: '#1972FF',   //柱状颜色
              }
            }
          }
        ],
        grid: {
          left: '16px',
          top:'15%',
          containLabel: true
        }
      },
      options: [],// 筛选下拉列表
      searchCriteria: '', // 下拉筛选条件
      searchCriteriaDate: '',//日期筛选条件
    }
  },
  computed: {
    chartBarStyl(){
      return {
        width: "100%",
        height: "500px",
      }
    },
  },
  mounted() {
    console.log(this.receiveProps,'chart-bar')
    let chartBarData = this.receiveProps.tempData.chartBarData;
    if (!chartBarData) { // 显示占位图
      this.placeholdVisible = true;
      return;
    } 
    let dataSettings = chartBarData.dataSettings;
    this.chartOption.xAxis.axisLine.show = dataSettings.axisLineXVisible; // X轴线
    this.chartOption.yAxis.axisLine.show = dataSettings.axisLineYVisible; // Y轴线
    this.chartOption.yAxis.splitLine.show = dataSettings.splitLineYVisible; // Y轴网格线
    this.chartOption.dataZoom.show = dataSettings.zoomRegionVisible == true ? true : false; // 是否缩放
    this.chartOption.xAxis.axisLabel.rotate = dataSettings.Xskewness; // x轴数据倾斜角度
    this.chartOption.legend.show = dataSettings.legendVisible; // 图例
    this.chartTitleVisible = dataSettings.chartTitleVisible; // 标题显隐
    this.chartTitle = dataSettings.chartTitle;// 标题
    this.dimType = chartBarData.dataContent.queryCondition.tableColumnDimType; // 查询条件0:时间维度 1：字符串维度
    this.queryCondition = chartBarData.dataContent.queryCondition.tableColumnName; // 查询条件 

    this.getChartBarData()
  },
  methods: {
    //获取柱图配置数据
    async getChartBarData(stringCondition = '',dateRange =null) {
      let { dataContent,dataSet,dataSettings } = this.receiveProps.tempData.chartBarData;
      let metricDto = dataContent.metricDto;
      let columns = []
      if (metricDto.length) {
        for (var i = 0; i< metricDto.length; i++) {
          columns.push(metricDto[i].tableColumnName)
        }
      }
      let params = {
        columns: columns,
        dashBoardFilter: { // 条件过滤
          enumId: dataContent.dataFilter, // 过滤id
          gt0: dataContent.measurement.tableColumnName, // 大于0的字段名
          tableColumnName: 'dim_date_type', // 字段名过滤条件
          top10: dataContent.topTen // 排序前十
        },
        dataSetId: dataSet.id, //数据集id
        dateRange: dateRange,
        dimType: dataContent.queryCondition.tableColumnDimType, // 查询维度类型
        queryTableColumn: dataContent.queryCondition.tableColumnName, // 查询条件
        stringCondition: stringCondition, // 下拉筛选条件
        axisDataColumn: dataContent.dimensionDto.tableColumnName,// 行 字段名
        sortData: {
          tableColumnName: dataContent.sortData && dataContent.sortData.tableColumnName ? dataContent.sortData.tableColumnName : '',
          sortDesc: dataContent.chartSort ? dataContent.chartSort : ''
        }
      }
      try {
        let res = await this.$apipcs.chart.getChartBarData(params);
        if (res.success) {
          let seriesList = res.data.seriesList
          if (seriesList.length) {
            seriesList.map((item) => {
              item.type = 'bar';
              item.barWidth = 30,//柱图宽度
              item.label = {
                show: dataSettings.chartLabelVisible,
                position: 'top',
                formatter:function(params){ //标签内容
                  let unitOfQuantity = dataContent.unitOfQuantity ? dataContent.unitOfQuantity : 1
                  let label = params.value / unitOfQuantity;
                  let decimalDigits = dataContent.decimalDigits ? dataContent.decimalDigits : 0;
                  let unitSuffixes = dataContent.unitSuffixes ? dataContent.unitSuffixes : '';
                  return label.toFixed(decimalDigits) + unitSuffixes
                }
              }
            })
          }
          this.chartOption.series = seriesList; // 柱图数据
          this.options = res.data.stringConditionList; // 筛选项
          this.chartOption.xAxis.data = res.data.xaxisData; // X轴数据
          // 绘制图表
          this.initChart()
        }
      } catch(err) {
        console.log(err);
      }
    },
    // 绘制图表
    initChart() {
      let myChart = echarts.init(this.$refs.chartBar);
      // 绘制图表
      myChart.setOption(this.chartOption)
      window.onresize = myChart.resize;
    },
    // 筛选条件
    handleSelectBar(val) {
      if (Array.isArray(val)) {
        this.getChartBarData('',{min:val[0],max: val[1]});
      } else {
        this.getChartBarData(val,null);
      }
    },
    // 筛选开始年限
    handleChangeStart(val) {
      if (!val && this.curEndYear) {
        this.getChartBarData('',{min: this.curEndYear,max: this.curEndYear});
      } else if (val && this.curEndYear){
        this.handleChangeEnd(this.curEndYear)
      }
    },
    // 筛选结束年限
    handleChangeEnd(val) {
      if (this.curStartYear && !val) return
      let max = val > this.curStartYear ? val : this.curStartYear;
      let min = val > this.curStartYear ? this.curStartYear: val;
      this.getChartBarData('',{min: min,max: max});
    }
  },
  destroyed () {
    window.onresize = null;
  }
};
</script>

<style lang="less" scoped>
  @import "../asset/chart.css";
  .chart-bar-box {
    max-width: 1200px;
    margin: 0 auto;
    // border: 1px solid #EEEEEE;
    margin-bottom: 16px;
  }
  .chart-cont-styl {
    padding: 16px 16px 16px 0;
    box-sizing: border-box;
    text-align: left;
    background: #fff;
  }
  .select-style {
    width: 240px;
    margin: 0px 0 16px 16px;
  }
</style>